<template>
  <div class="main">
    <div class="header">
      <PageHeader />
    </div>
    <div class="mainBody">
      <div class="mainBodyDiv">
        <Loading v-if="loading" />
        <ServerMessage v-if="snackbar" />
        <v-card class="card" width="600">
          <v-card-title class="title font-weight-regular justify-space-between">
            <b class="titleB">{{ currentTitle }}</b>
          </v-card-title>
          <v-window v-model="step">
            <v-window-item :value="1">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12">
                    <div class="labelDiv">
                      <label>Firstname <span>*</span> </label>
                    </div>
                    <v-text-field
                      v-model="firstname"
                      class="fieldtx"
                      outlined
                      dense
                    ></v-text-field>
                    <div class="labelDiv">
                      <label>Middlename <span>*</span> </label>
                    </div>
                    <v-text-field
                      v-model="middlename"
                      class="fieldtx"
                      outlined
                      dense
                    ></v-text-field>
                    <div class="labelDiv">
                      <label>Surname <span>*</span></label>
                    </div>
                    <v-text-field
                      v-model="lastname"
                      class="fieldtx"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-window-item>
            <v-window-item :value="2">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12">
                    <div class="labelDiv">
                      <label>Email Address <span>*</span> </label>
                    </div>
                    <v-text-field
                      v-model="email"
                      class="fieldtx"
                      outlined
                      dense
                    ></v-text-field>
                    <div class="labelDiv">
                      <label><b>Phone number</b></label>
                    </div>
                    <v-text-field v-model="mobileNumber" type="number" outlined>
                      <template slot="prepend-inner">
                        <div class="flag">
                          <img
                            src="../assets/flag.png"
                            alt="teller logo"
                            width="35"
                            height="25"
                          />
                          <p class="num">+234</p>
                        </div>
                      </template>
                    </v-text-field>
                    <div class="labelDiv">
                      <label>Choose your location <span>*</span> </label>
                    </div>
                    <div class="selectDiv">
                      <select class="select" v-model="stateCode">
                        <option
                          class="option"
                          v-for="locations in location"
                          :key="locations.label"
                          :value="locations.value"
                          >{{ locations.label }}</option
                        >
                      </select>
                      <div class="selectarrow">
                        <v-icon class="iconColor">mdi-arrow-down</v-icon>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </v-window-item>
            <v-window-item :value="3">
              <div class="pa-4">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12">
                      <div class="labelDiv">
                        <label>Setup PIN<span>*</span> </label>
                      </div>
                      <v-text-field
                        v-model="pin"
                        class="fieldtx"
                        outlined
                        dense
                      ></v-text-field>
                      <div class="labelDiv">
                        <label>Confirm PIN<span>*</span> </label>
                      </div>
                      <v-text-field
                        v-model="ConFimPIn"
                        class="fieldtx"
                        outlined
                        dense
                      ></v-text-field>
                      <div class="labelDiv">
                        <label
                          >If you were marketed by our staff, please enter
                          his/her 6-digit code below</label
                        >
                      </div>
                      <v-text-field
                        class="fieldtx"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </div>
            </v-window-item>
            <v-window-item :value="4">
              <div class="pa-4">
                <p class="title font-weight-light ml-4 otpboxP">
                  Enter the OTP sent to {{ mobileNumber }}
                </p>
                <div class="otpbox">
                  <v-text-field
                    focus
                    v-model="otp"
                    class="fieldtx"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <div @click="resendOtp()" class="resend">
                  <p>Didn’t recieve OTP ? <b> RESEND </b></p>
                </div>
              </div>
            </v-window-item>
            <v-window-item :value="5">
              <div class="pa-4">
                <div class="shield">
                  <img
                    src="../assets/shield.png"
                    alt="teller logo"
                    width="150"
                    height="150"
                  />
                </div>
              </div>
            </v-window-item>
          </v-window>
          <v-card-actions>
            <div v-if="step > 1 && step < 4">
              <v-btn text @click="goback(step - 1)">
                <span class="back"> go back</span>
              </v-btn>
            </div>
            <div v-if="step == 1" @click="navigate('login')" class="login">
              <p>Already have an account ? <b>Sign In</b></p>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              dark
              large
              :disabled="step === 5"
              class="nextBtn"
              color="blue-grey"
              @click="next(step + 1)"
            >
              Next
              <v-icon right dark>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
          <v-divider class="mar"></v-divider>
          <div v-if="step == 5" class="stepDiv">
            <v-btn dark large class="nextBtn" @click="navigate('login')">
              Continue
              <v-icon right dark>mdi-arrow-right</v-icon>
            </v-btn>
          </div>
          <div v-else class="stepDiv">
            <div v-if="step == 1" class="step">
              <small class="white--text">{{ step }}</small>
            </div>
            <div v-else-if="step > 1" class="stepcheckbox">
              <small class="white--text">
                <v-icon class="color-green"
                  >mdi-checkbox-marked-circle</v-icon
                ></small
              >
            </div>
            <div v-else class="stepdisable">
              <small class="white--text">1</small>
            </div>
            <div v-if="step == 2" class="step">
              <small class="white--text">{{ step }}</small>
            </div>
            <div v-else-if="step > 2" class="stepcheckbox">
              <small class="white--text">
                <v-icon class="color-green"
                  >mdi-checkbox-marked-circle</v-icon
                ></small
              >
            </div>
            <div v-else class="stepdisable">
              <small class="white--text">2</small>
            </div>
            <div v-if="step == 3" class="step">
              <small class="white--text">{{ step }}</small>
            </div>
            <div v-else-if="step > 3" class="stepcheckbox">
              <small class="white--text">
                <v-icon class="color-green"
                  >mdi-checkbox-marked-circle</v-icon
                ></small
              >
            </div>
            <div v-else class="stepdisable">
              <small class="white--text">3</small>
            </div>
            <div v-if="step == 4" class="step">
              <small class="white--text">{{ step }}</small>
            </div>
            <div v-else-if="step > 4" class="stepcheckbox">
              <small class="white--text">
                <v-icon class="color-green"
                  >mdi-checkbox-marked-circle</v-icon
                ></small
              >
            </div>
            <div v-else class="stepdisable">
              <small class="white--text">4</small>
            </div>
            <div v-if="step == 5" class="step">
              <small class="white--text">{{ step }}</small>
            </div>
            <div v-else class="stepdisable">
              <small class="white--text">5</small>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <div class="mainfooter">
      <AppFooter />
    </div>
  </div>
</template>

<script>
import PageHeader from "../components/Header";
import AppFooter from "../components/AppFooter";
export default {
  metaInfo: {
    title: "Teller/Signup",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    PageHeader,
    AppFooter,
  },
  data: () => ({
    pin: "",
    ConFimPIn: "",
    firstname: "",
    middlename: "",
    lastname: "",
    email: "",
    mobileNumber: "",
    otp: "",
    stateCode: "",
    referralStaffID: "",
    location: [
      { label: "Abia", value: "101" },
      { label: "Adamawa", value: "102" },
      { label: "Akwa Ibom", value: "103" },
      { label: "Anambra", value: "104" },
      { label: "Bauchi", value: "105" },
      { label: "Bayelsa", value: "106" },
      { label: "Benue", value: "107" },
      { label: "Borno", value: "108" },
      { label: "Cross River", value: "109" },
      { label: "Delta", value: "110" },
      { label: "Ebonyi", value: "111" },
      { label: "Enugu", value: "112" },
      { label: "Edo", value: "113" },
      { label: "Ekiti", value: "114" },
      { label: "Gombe", value: "115" },
      { label: "Imo", value: "116" },
      { label: "Jigawa", value: "117" },
      { label: "Kaduna", value: "118" },
      { label: "Kano", value: "119" },
      { label: "Katsina", value: "120" },
      { label: "Kebbi", value: "121" },
      { label: "Kogi", value: "122" },
      { label: "Kwara", value: "123" },
      { label: "Lagos", value: "124" },
      { label: "Nasarawa", value: "125" },
      { label: "Niger", value: "126" },
      { label: "Ogun", value: "127" },
      { label: "Ondo", value: "128" },
      { label: "Osun", value: "129" },
      { label: "Oyo", value: "130" },
      { label: "Plateau", value: "131" },
      { label: "Rivers", value: "132" },
      { label: "Sokoto", value: "133" },
      { label: "Taraba", value: "134" },
      { label: "Yobe", value: "135" },
      { label: "Zamfara", value: "136" },
      { label: "FCT", value: "137" },
    ],
    images: { img: require("../assets/Bg.png") },
  }),
  methods: {
    navigate(to) {
      this.$router.push({ name: to });
    },
    goback(payload) {
      this.$store.commit("setSignUpStep", payload);
    },
    next(payload) {
      if (this.step == 1) {
        if (this.firstname == "" || this.lastname == "") {
          let payload = {
            status: true,
            message: "Fill out all the required fields",
          };
          this.$store.dispatch("SnackbarFunc", payload);
          return;
        }
        this.$store.commit("setSignUpStep", payload);
        return;
      }
      if (this.step == 2) {
        if (this.stateCode == "" || this.mobileNumber == "") {
          let payload = {
            status: true,
            message: "Fill out all the required fields",
          };
          this.$store.dispatch("SnackbarFunc", payload);
          return;
        }
        this.$store.commit("setSignUpStep", payload);
        return;
      }
      if (this.step == 3) {
        if (this.pin == "" || this.ConFimPIn == "") {
          let payload = {
            status: true,
            message: "Fill out all the required fields",
          };
          this.$store.dispatch("SnackbarFunc", payload);
          return;
        }
        if (this.pin != this.ConFimPIn) {
          let payload = {
            status: true,
            message: "Pin dont match",
          };
          this.$store.dispatch("SnackbarFunc", payload);
          return;
        }
        console.log(payload);
        let payload = {
          pin: this.pin,
          firstname: this.firstname,
          lastname: this.lastname,
          middlename: this.middlename,
          mobileNumber: this.mobileNumber,
          email: this.email,
          statecode: this.stateCode,
        };
        this.$store.dispatch("RegistrationRequestFuc", payload);
      }

      if (this.step == 4) {
        let payload = {
          customerID: this.customerID,
          otpCode: this.otpCode,
        };

        this.$store.dispatch("SendVerificationCode", payload);
      }
    },
    resendOtp() {
      let payload = {
        customerID: this.customerID,
      };
      this.$store.dispatch("resendOtp", payload);
    },
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Sign-up";
        case 2:
          return "Create Account";
        case 3:
          return "Create Pin";
        case 4:
          return "OTP Verification";
        case 5:
          return "Verification Successful";
        default:
          return "Create Account";
      }
    },

    loading() {
      return this.$store.state.User.loading;
    },
    snackbar() {
      return this.$store.state.User.snackbar;
    },
    step() {
      return this.$store.state.User.step;
    },
    customerID() {
      return this.$store.state.User.customerID;
    },
  },
};
</script>

<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(50px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "header header header header"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainBody mainBody mainBody mainBody"
    "mainfooter mainfooter mainfooter mainfooter";
  width: 100%;
}

.header {
  grid-area: header;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.mainBody {
  grid-area: mainBody;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}
.mainBodyDiv {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/Bg.png");
  background-size: cover;
}
.mainfooter {
  grid-area: mainfooter;
}

.card {
  border-radius: 20px !important;
  padding: 30px;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11);
  background-color: #ffffff;
}
.num {
  margin-top: 5px;
  color: black;
}
.stepDiv {
  display: flex;
  justify-content: center;
}
.step {
  background-color: #ad1684;
  text-align: center;
  padding: 2px;
  margin: 5px;
  width: 20px;
  border-radius: 60px;
}
.step small {
  color: white;
}
.stepcheckbox {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 60px;
  margin: 5px;
}
.color-green {
  color: #56c47f;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 14px;
  text-transform: none;
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.login p {
  color: #ad1684;
}
.stepdisable {
  background-color: #c4c4c4;
  text-align: center;
  padding: 2px;
  margin: 5px;
  width: 20px;
  border-radius: 60%;
}
.titleB {
  color: #ad1684 !important;
}
.select {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  background-color: #e3e3e3;
}

.selectDiv {
  position: relative;
}
.selectarrow {
  position: absolute;
  top: 15px;
  right: 10px;
  background-color: #ad1684;
}
.phone {
  margin-bottom: 25px;
}
.iconColor {
  color: white;
  font-size: 15px;
}

label span {
  color: red;
}
.labelDiv {
  padding-bottom: 5px;
}
.fieldtx {
  border-radius: 5px;
}
.otpbox {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 150px;
}
.otpboxDiv {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3px;
  height: 50px;
  width: 50px;
  border-radius: 5px;
  background-color: white;
  border: solid;
  border-width: 0.5px;
  border-color: #283a90;
}
.otpboxP {
  margin-left: 15px;
  font-size: 14px;
}
.resend {
  display: flex;
  justify-content: center;
}
.resend p {
  font-size: 14px;
  margin: 50px;
  cursor: pointer;
}
.resend b {
  color: red;
}
.mar {
  margin-top: 10px;
  margin-bottom: 10px;
}
.back {
  color: #ad1684;
  text-transform: none;
}
.shield {
  display: flex;
  justify-content: center;
}
.flag {
  display: flex;
  justify-content: center;
}
.flag img {
  margin-right: 3px;
}
@media only screen and (max-width: 700px) {
  .card {
    width: 350px !important;
  }
}
</style>
